// removed by extract-text-webpack-plugin
module.exports = {"accountItemSetting":"_3Q_ihi86qtGmZzEAyb9wr8","img":"_2jqLZhZ02j9NMcmihuqep7","arrow":"_2sEAMYqa6MVMOARA0Cg7HJ","middleView":"_3l8_eMk9rAWvw2eL-TaDfy","textMiddle":"uP-mPTCyTlJhRxIaWCznL","pointView":"_1SQj_420T1iM9p7rSxWXia","pointText":"_1BVIQJXngD3qVwy2XhL3P3","arrowView":"_6gTeCh7SzDqP89d15tkDW","leftArrow":"_1fiEBujezLNeNxjvf0V3Ja"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/AccountItem.scss
// module id = 1082
// module chunks = 0